const formatPreviewValue = (value) => {
    if (!value) return '';
    return value.length > 36 ? `${value.slice(0, 36)}...` : value;
};

export function MediaFileRow({ icon, iconColor, value, onDelete, compact = false }) {
    const wrapClass = compact
        ? 'flex items-center justify-between rounded bg-white/5 px-2 py-1 text-[10px] text-gray-300'
        : 'flex items-center justify-between rounded-md bg-white/5 px-2 py-1 text-[10px] text-gray-300';
    const spanClass = compact ? 'truncate text-[9px]' : 'truncate';
    return (
        <div className={wrapClass}>
            <span className={spanClass}>
                <i className={`${icon} mr-1`} style={{ color: iconColor }} />
                {formatPreviewValue(value)}
            </span>

        </div>
    );
}

export function AutoDeleteField({ value, onToggle, onChangeSeconds, compact = false }) {
    const labelClass = compact
        ? 'flex items-center gap-1.5 text-[9px] text-gray-400 cursor-pointer'
        : 'flex items-center gap-2 text-[10px] text-gray-300';
    const checkClass = compact
        ? 'h-2.5 w-2.5 rounded border-white/20 bg-white/10'
        : 'h-3 w-3 rounded border-white/20 bg-white/10';
    const inputClass = compact ? 'input3 w-16 text-[10px]' : 'input3 w-[30%]';

    return (
        <>
            <label className={labelClass}>
                <input type="checkbox" className={checkClass}
                    checked={Boolean(value)}
                    onChange={(e) => onToggle(e.target.checked)} />
                <span>Auto-deletar</span>
            </label>
            {Boolean(value) && (
                <div className="flex items-center gap-2">
                    <input type="number" min="3" className={inputClass}
                        value={value || ''}
                        onChange={(e) => onChangeSeconds(parseInt(e.target.value) || 5)} />
                    <span className="text-[10px] text-gray-400">segundos</span>
                </div>
            )}
        </>
    );
}

export function MediaUploadLabel({ accept, onUpload }) {
    return (
        <label className="relative border-2 border-dashed rounded-lg p-3 transition-colors cursor-pointer border-white/[0.06] hover:border-white/[0.08] flex flex-col items-center gap-1">
            <input accept={accept} className="hidden" type="file"
                onChange={(e) => { const f = e.target.files?.[0]; if (f) onUpload(f); e.target.value = ''; }} />
            <i className="fas fa-cloud-upload-alt text-white/30 text-lg" />
            <p className="text-[10px] text-white/50">Arraste ou clique</p>
            <p className="text-[9px] text-white/30">para fazer upload</p>
        </label>
    );
}
